//@flow
import React, {useEffect} from 'react';
import PermissionHOC from "../../modules/permission/components/permissionHOC/permissionHOC";
import { DefaultLanguages, Languages, Permissions } from "../../helpers/constants";
import {useExhibition} from "../../hooks/exhibitions/useExhibition";
import ContentLoader from "../../components/general/contentLoader/contentLoader";
import OrganizerMain from "./partials/organizer/main/main";
import ExhibitorMain from "./partials/exhibitor/main/main";
import ExhibitionPageTitle from "../../components/app/exhibitionPageTitle/exhibitionPageTitle";
import useUserAction from "../../hooks/user/useUserAction";
import WrapperWithSettingsButton from "./partials/organizer/main/partials/wrapperWithSettingsButton";

const Exhibition = () => {
    const {exhibition, loading} = useExhibition()
    const {setUserLanguage} = useUserAction()
    useEffect(() => {
        if (exhibition?.defaultLanguage === DefaultLanguages.EN) {
            setUserLanguage(Languages.EN)
        }
        if (exhibition?.defaultLanguage === DefaultLanguages.EL) {
            setUserLanguage(Languages.EL)
        }
    }, [exhibition?.defaultLanguage, setUserLanguage])
    return (
        <React.Fragment>
            {exhibition ? (
                <React.Fragment>
                    <PermissionHOC requiredPermissions={[Permissions.BeOrganizer]}>
                        <WrapperWithSettingsButton id={exhibition.id}>
                            <ExhibitionPageTitle exhibition={exhibition}/>
                            <OrganizerMain/>
                        </WrapperWithSettingsButton>
                    </PermissionHOC>
                    <PermissionHOC requiredPermissions={[Permissions.BeExhibitor]}>
                        <ExhibitorMain/>
                    </PermissionHOC>
                </React.Fragment>
            ) : <ContentLoader loading={loading}/>}
        </React.Fragment>
    )
}

export default Exhibition;